// @flow
export { default as AdvisersStorefrontJumboSmall } from './AdvisersStorefrontJumboSmall';
